import { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
//MaterialUI
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import UnfoldMoreIcon from "@material-ui/icons/UnfoldMore";
import Pagination from "@material-ui/lab/Pagination";

import TableBackdrop from "components/Backdrops/TableBackdrop/TableBackdrop";
import CardTableContainer from "components/Cards/Tables/CardTableContainer";
import TableStateChip from "components/Cards/Tables/TableStateChip";
import { FOLLOWUP_STATE_KEY_QUERY, PAGINATION, TABLE_STATE_CHIP_COLOR } from "utils/const";
import { getMyBenefitsFollowUp } from "crud/benefits.crud";
import limitaString from "utils/string_utils";
import moment from "moment";

import componentStylesGeneric from "assets/theme/views/admin/generic";

const useStylesGeneric = makeStyles(componentStylesGeneric);

const BENEFIT_STATE_KEY = {
  APROVADO: "Approved",
  EM_PAGAMENTO: "InPayment",
};

function MyBenefitsFollowUpsTab({ followUpState }) {
  const theme = useTheme();
  const classes = useStylesGeneric();

  const [pageIndex, setPageIndex] = useState(PAGINATION.FIRST_PAGE);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const tableHead = [
    { label: "Data de Submissão", sortKey: "submissionDate" },
    { label: "Nº Candidatura", sortKey: "applicationNumber" },
    { label: "Beneficiário", sortKey: "beneficiary" },
    { label: "Tipo de Benefício", sortKey: "benefitType" },
    { label: "Programa", sortKey: "program" },
    { label: "Estado", sortKey: "state" },
  ];

  const handleChangePage = (event, value) => {
    setPageIndex(value);
  };

  const handleSort = (columnIndex) => {
    const column = tableHead[columnIndex].sortKey;
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
    setPageIndex(PAGINATION.FIRST_PAGE);
  };

  const renderSortIcon = (columnIndex) => {
    const column = tableHead[columnIndex].sortKey;
    if (sortColumn === column) {
      return sortDirection === "desc" ? (
        <ArrowUpwardIcon style={{ fontSize: 16, marginLeft: 4, verticalAlign: "middle" }} />
      ) : (
        <ArrowDownwardIcon style={{ fontSize: 16, marginLeft: 4, verticalAlign: "middle" }} />
      );
    }
    return <UnfoldMoreIcon style={{ fontSize: 16, marginLeft: 4, verticalAlign: "middle", opacity: 0.3 }} />;
  };

  const mapBenefitStateToTableChipColor = (stateKey) => {
    switch (stateKey) {
      case BENEFIT_STATE_KEY.APROVADO:
        return TABLE_STATE_CHIP_COLOR.GREEN;
      case BENEFIT_STATE_KEY.EM_PAGAMENTO:
        return TABLE_STATE_CHIP_COLOR.BLUE;
      default:
        return TABLE_STATE_CHIP_COLOR.YELLOW;
    }
  };

  const getFollowUpStateDescription = () => {
    switch (followUpState) {
      case FOLLOWUP_STATE_KEY_QUERY.ONGOING:
        return "em curso";
      case FOLLOWUP_STATE_KEY_QUERY.FINISHED:
        return "concluídos";
      default:
        return "";
    }
  };

  useEffect(() => {
    setLoading(true);
    getMyBenefitsFollowUp({
      FollowUpStateKey: followUpState,
      PageIndex: pageIndex,
      PageSize: PAGINATION.PAGE_SIZE,
      SortColumn: sortColumn,
      SortDirection: sortDirection,
    })
      .then((response) => {
        setData(response.data.data ?? []);
        setTotalPages(response.data.totalPages ?? 0);
        setTotalCount(response.data.totalCount ?? 0);
      })
      .catch(() => {
        setData([]);
        setTotalPages(0);
        setTotalCount(0);
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex, followUpState, sortColumn, sortDirection]);

  useEffect(() => {
    setPageIndex(PAGINATION.FIRST_PAGE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [followUpState]);

  return (
    <>
      <CardTableContainer
        title={`Benefícios Recebidos ${getFollowUpStateDescription()}`}
        count={totalCount}
      >
        <TableContainer>
          <Box component={Table} alignItems="center" marginBottom="0!important">
            <TableHead>
              <TableRow>
                {tableHead.map((prop, key) => (
                  <TableCell
                    key={key}
                    classes={{
                      root: classes.tableCellRoot + " " + classes.tableCellRootHead,
                    }}
                    onClick={() => handleSort(key)}
                    style={{ cursor: "pointer", userSelect: "none" }}
                  >
                    <Box display="flex" alignItems="center">
                      {prop.label}
                      {renderSortIcon(key)}
                    </Box>
                  </TableCell>
                ))}
                <TableCell
                  key="detailsCol"
                  classes={{
                    root:
                      classes.tableCellRoot +
                      " " +
                      classes.tableCellRootHead +
                      " " +
                      classes.tableCellHeadStickyRight,
                  }}
                >
                  Ver Detalhes
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((prop, key) => (
                <TableRow key={key}>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                    <Box>{prop.submissionDate ? moment(prop.submissionDate).format("DD/MM/YYYY") : "-"}</Box>
                  </TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                    <Box>{prop.applicationNumber}</Box>
                  </TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                    <Box>{limitaString(prop.beneficiary, 60)}</Box>
                  </TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                    <Box>{limitaString(prop.benefitType, 60)}</Box>
                  </TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                    <Box>{limitaString(prop.program, 60)}</Box>
                  </TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                    <TableStateChip
                      state={mapBenefitStateToTableChipColor(prop.stateKey)}
                      message={prop.state}
                    />
                  </TableCell>
                  <TableCell
                    classes={{
                      root: classes.tableCellRoot + " " + classes.tableCellBodyStickyRight,
                    }}
                  >
                    <Tooltip title="Ver Detalhes">
                      <IconButton
                        aria-label="details"
                        component={Link}
                        to={{
                          pathname: `/admin/my-benefits-details/${prop.applicationNumber}`,
                          state: { loanId: prop.loanId, subsidyId: prop.subsidyId, benefitType: prop.benefitTypeKey },
                        }}
                      >
                        <Box
                          component={ArrowForwardIosIcon}
                          width="12px!important"
                          height="12px!important"
                          color={theme.palette.primary.main}
                        />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Box>
          <TableBackdrop open={loading} />
        </TableContainer>

        <Pagination
          className={classes.alignPagination}
          count={totalPages}
          page={pageIndex}
          onChange={handleChangePage}
          color="primary"
        />
      </CardTableContainer>
    </>
  );
}

export default MyBenefitsFollowUpsTab;
